(() => {
  try {
    const originalAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (options) {
      const shadowRoot = originalAttachShadow.call(this, options);

      if (this.tagName && this.tagName.toLowerCase().includes('magic-checkout')) {
        try {
          const customStyle = document.createElement('style');
          customStyle.textContent = `
            #razorpay-magic-btn,
            [data-testid="magic-btn-v3"],
            button[data-variant="magic-btn-v3"] {
              border: 1px solid #ffffff !important;
              border-radius: 0px !important;
            }
            #razorpay-magic-btn .overlay {
              border-radius: 0px !important;
            }
          `;
          shadowRoot.appendChild(customStyle);

          const applyStyles = () => {
            const buttonElement = shadowRoot.querySelector('#razorpay-magic-btn, [data-testid="magic-btn-v3"]');
            if (buttonElement) {
              buttonElement.style.setProperty('border', '1px solid #ffffff', 'important');
              buttonElement.style.setProperty('border-radius', '0px', 'important');
            }
            const overlay = shadowRoot.querySelector('#razorpay-magic-btn .overlay');
            if (overlay) {
              overlay.style.setProperty('border-radius', '0px', 'important');
            }
          };

          applyStyles();

          const observer = new MutationObserver(() => {
            applyStyles();
          });
          observer.observe(shadowRoot, { childList: true, subtree: true });
        } catch (innerError) {
          console.warn('Failed to inject custom style into Razorpay shadow DOM', innerError);
        }
      }

      return shadowRoot;
    };
  } catch (error) {
    console.warn('Failed to initialize Razorpay style interceptor', error);
  }
})();
